import { flagFactory } from '../icon';
import Svg from './ee.svg';

export default flagFactory(Svg);
